var staticStrLast = 'last'

module.exports = staticStrLast
